module.exports = __webpack_public_path__ + "img/aliados_fundacion.eacfc8ba.jpg";